/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Humanize from 'humanize-plus';

import showErrorMessage from '../util/showErrorMessage';

import tmplFileUpload from './FileUploadTmpl.hbs';
import tmplFileDownload from './FileDownloadTmpl.hbs';
import tmplFileDownloadInternal from './FileDownloadInternalTmpl.hbs';

const MAX_FILE_SIZE = 314572800; // 300 MB

const fileUploadConfig = {
  pathToFileId: 'html.head.script.Envelope.Body.UploadDocumentResponse.AttachmentID.__text',
  downloadXml: tmplFileDownload,
  downloadInternalXml: tmplFileDownloadInternal,
  uploadXml: tmplFileUpload,
  timeout: 3000000,
  sizeLimit: MAX_FILE_SIZE,
  searchPath: '/FilePath',
  failedAdd(data) {
    // Handle showing error message for file too large error.
    const fileSizeHuman = Humanize.fileSize(data.file.size);
    const maxFileSizeHuman = Humanize.fileSize(MAX_FILE_SIZE);

    showErrorMessage({
      errorCode: 'max.file-size.exceeded',
      errorTitle: 'File Too Large',
      errorMessage: `The file selected, which has size ${fileSizeHuman}, exceeds the maximum file size of ${maxFileSizeHuman}`
    });
  }
};

export default fileUploadConfig;
